import React, { Component } from 'react';
// import Chip from '@material-ui/core/Chip';
// import DoneIcon from '@material-ui/icons/Done';
// import AddIcon from '@material-ui/icons/Add';
import { RegionOption } from '../helper/constants/options';
import { ChipComponent } from './ChipComponent';
class RegionComponent extends Component {
  // ### always return array of object 

  onClick = (isMulti, newValue) => {
    let { value = [], onChange } = this.props;
    if (!value) {
      value = [];
    }
    if (value && onChange && newValue) {
      let vvalue = [...value];
      if (isMulti) {
        let index = Array.isArray(value) ? value.findIndex(v => v.value === newValue.value) : -1;
        if (index >= 0) {
          vvalue.splice(index, 1);
          onChange(vvalue);
        } else {
          vvalue.push(newValue)
          onChange(vvalue);
        }
      } else {
        // replace value if not isMulti
        onChange([newValue]);
      }
    }
  }
  render() {
    const {
      viewOnly = false,
      style,
      value = [],
      options = RegionOption,
      isMulti = true,
      className,
    } = this.props;
    const styles = {
      group: {

      },
      ...style,
    }
    const customClass = {
      group: '',
      ...className,
    }
    return (
      <div style={{ display: 'flex', alignItems: 'flex-start', ...styles.group }} className={customClass.group}>
        {options.map((ro, index) => {
          return (
            // <Chip
            //   key={index}
            //   className={index === (RegionOption.length - 1) ? '' : 'mr-1'}
            //   label={ro.label}
            //   clickable
            //   onClick={() => this.onClick(isMulti, ro)}
            //   variant={((value ? value.length > 0 : false ) ? value.some(v => v.value === ro.value) : false) ? 'default' : 'outlined'}
            // />
            <ChipComponent
              key={index}
              label={ro.label}
              className={index === (RegionOption.length - 1) ? '' : 'mr-1'}
              onClick={() => viewOnly ? true : this.onClick(isMulti, ro)}
              style={{ cursor: viewOnly ? 'auto' : 'pointer' }}
              selected={(value ? value.length > 0 : false) ? value.some(v => v.value === ro.value) : false}
            />
          )
        })

        }
      </div>
    );
  }
}

export default RegionComponent;